import classNames from 'classnames';
import dynamic from 'next/dynamic';
import Trans from 'next-translate/Trans';

import { SuccessIcon } from '@/icons/index';

import Button from '../Button/Button';

import styles from './InformationModal.module.scss';

const DinamicModal = ({ className, ...props }) => {
  const Component = dynamic(() => import('../Modal/Modal').catch(() => ''));

  return <Component className={className} {...props} />;
};

const InformationModal = ({
  active = false,
  onClose = () => null,
  title,
  description = <Trans i18nKey={'common:successText'} />,
  type = 'white',
  Icon,
}) => {
  return (
    <DinamicModal
      active={active}
      setActive={onClose}
      itemScope
      itemType='http://schema.org/Thing'
    >
      <div className={styles.successPopup}>
        <div
          data-testid='icon'
          className={classNames(styles.icon, {
            [styles.white]: type === 'white',
            [styles.dark]: type === 'dark',
          })}
        >
          {Icon !== null && typeof Icon === 'undefined' ? (
            <SuccessIcon width={54} />
          ) : (
            <Icon />
          )}
        </div>
        {title && <div className={styles.title}>{title}</div>}
        <div className={styles.text}>{description}</div>
        <Button onClick={onClose} className={styles.button}>
          <Trans i18nKey={'common:tariffSupport.success.button'} />
        </Button>
      </div>
    </DinamicModal>
  );
};

export default InformationModal;
